import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  padding: 0 48px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-self: center;
  justify-content: center;
  max-width: 600px;
  width: 100%;
  gap: 16px;
  flex: 1;

  ${({ theme }) => theme.media.mobile} {
    flex-direction: column;
    align-items: center;
  }
`;

export const BtnWrapperSameLine = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-self: center;
  align-items: center;
  max-width: 600px;
  width: 100%;
  margin-top: 32px;
`;
export const ErrorWrapper = styled.div`
  display: flex;
  align-self: center;
  max-width: 600px;
  width: 100%;
`;
